import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PushedDeal } from '../models/pushed-deal';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  addSubscription(sub: PushSubscription) {
    const host = environment.host;
    return lastValueFrom(
      this.http.post(host + '/products/subscription', { sub })
    );
  }

  removeSubscription(endpoint: string) {
    const host = environment.host;
    return lastValueFrom(
      this.http.delete(host + '/products/subscription', { body: { endpoint } })
    );
  }

  notifications(data: string, keyNotification: string) {
    const host = environment.host;
    return lastValueFrom(
      this.http.post(host + '/products/notifications/' + encodeURIComponent(keyNotification), { data })
    );
  }

  // Derniers deals envoyés en notification (liste de la cloche)
  history(limit = 20) {
    const host = environment.host;
    return this.http.get<PushedDeal[]>(host + '/products/notifications/history/' + limit);
  }

  generateVAPIDKeys(){
    const host = environment.host;
    return this.http.get<any>(host +'/products/notifications/generateVAPIDKeys');
  }
}
